<!-- 
Toolbar shown across the top of each widget.

As well as showing the title of the widget, also handles UI for dragging, refreshing,
toggling and removing the widget.
-->
<template>
  <v-toolbar :dense="!forDialog" :color="(!forDialog ? '' : 'secondary')" :class="(!forDialog ? '' : 'theme--dark')" flat>
    <v-toolbar-title :class="{'drag-handle': !fixed, 'widget-heading': !forDialog}">
      <v-tooltip v-if="!fixed" bottom>
        <v-icon slot="activator" class="drag_indicator">drag_indicator</v-icon>
        <span>Click and drag to rearrange your dashboard layout</span>
      </v-tooltip>
      {{ title }}
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-title>
      <v-tooltip v-if="hasToggleChartTypeListener" bottom>
        <v-btn slot="activator" icon class="ml-0 mr-1 refresh-button" @click.stop.prevent="$emit('toggleChartType')">
          <v-icon color="grey darken-1">insert_chart_outlined</v-icon>
        </v-btn>
        <span>Click to toggle chart type</span>
      </v-tooltip>
      <v-tooltip v-if="hasRefreshListener" bottom>
        <v-btn slot="activator" icon class="ml-0 mr-1 refresh-button" @click.stop.prevent="$emit('refresh')">
          <v-icon color="grey darken-1">refresh</v-icon>
        </v-btn>
        <span>Click to refresh widget contents</span>
      </v-tooltip>
      <v-tooltip v-if="hasRemoveListener && !fixed" bottom>
        <v-btn slot="activator" icon class="ml-0 mr-1 remove-button" @click.stop.prevent="$emit('remove')">
          <v-icon color="grey darken-1">close</v-icon>
        </v-btn>
        <span>Click to remove widget</span>
      </v-tooltip>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    forDialog: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasToggleChartTypeListener() {
      return this.$listeners && this.$listeners.toggleChartType;
    },
    hasRefreshListener() {
      return this.$listeners && this.$listeners.refresh;
    },
    hasRemoveListener() {
      return this.$listeners && this.$listeners.remove;
    }
  }
};
</script>
